import { SVGAttributes } from 'react';

export function EditLineIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M2 3v6h2.95l2 6H6v6h6v-4.59L17.41 11H22V5h-6v4.57L10.59 15H9.06l-2-6H8V3zm2 2h2v2H4zm14 2h2v2h-2zm3.15 6c-.15 0-.28.05-.39.16l-1.01 1.02l2.07 2.07l1.02-1.01c.21-.21.21-.57 0-.78l-1.3-1.3a.54.54 0 0 0-.39-.16m-2 1.76L13 20.91V23h2.09l6.14-6.16zM8 17h2v2H8z"
      />
    </svg>
  );
}
